import { KpiConfigurationForm } from '../../components/kpi-configuration-form/kpi-configuration-form';

export const KpiConfigurationPage = () => (
  <div className="flex w-full flex-col gap-4">
    <KpiConfigurationForm />
  </div>
);
